<template>
  <el-row>
    <el-col>
      <el-breadcrumb separator="/" class="admincrumb">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>店铺</el-breadcrumb-item>
        <el-breadcrumb-item>分类管理</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <el-col class="'toolbar">
      <el-form :inline="true" :model="sData" :rules="addrules" ref="ruleForm" size="mini" class="form-inline">
        <el-form-item label="分类名称">
          <el-input v-model="sData.showName_icontains" placeholder="请输入分类名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button-group>
            <el-button type="primary" @click="sSubmit"><i class="el-icon-search" style="font-weight: bolder; margin-right: 6px;"></i>标签组搜索</el-button>
            <el-button type="primary" @click="routeRepair"><i class="fa fa-refresh" style="font-weight: bolder; margin-right: 6px;"></i>重新生成路由</el-button>
          </el-button-group>
        </el-form-item>
      </el-form>
    </el-col>
    <el-col>
      <el-row>
        <el-col :span="14" class="block">
          <el-col>
            <el-tree :props="initCategoryProps"
                     @node-click="clickNode"
                     v-loading="loading"
                     :load="loadCategory"
                     node-key="PID_id"
                     ref="tree"
                     highlight-current
                     lazy
                     show-checkbox
                     draggable
                     :expand-on-click-node="false">
               <span class="custom-tree-node" slot-scope="{ store, node, data }">
                <span>{{ node.label }}</span>
                <span>
                  <el-button type="text" size="mini" @click="append(data)"><i class="el-icon-plus"></i>新增</el-button>
                  <el-button type="text" size="mini" @click="categoryedit(data)"><i class="el-icon-edit"></i>编辑</el-button>
                  <el-button type="text" size="mini" @click="makecover(data)"><i class="el-icon-view"></i>封面</el-button>
                  <el-button type="text" size="mini" @click="sortnum(data)"><i class="el-icon-sort"></i>排序</el-button>
                  <el-dialog :visible.sync="coverupshow" :before-close="handleClose" width="30%">
                    <span>
                      <el-upload
                        :span="12"
                        class="avatar-uploader catcover"
                        :data="uploadattr"
                        accept="image/*"
                        name="upload"
                        :headers="$verifyhead"
                        :action="upurl"
                        :show-file-list="false"
                        :on-success="handleCoverSuccess">
                        <img v-if="currCover.cover" :src="currCover.cover" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                    </span>
                  </el-dialog>
                </span>
              </span>
            </el-tree>
            <el-dialog :visible.sync="addattriDialogVisible" :before-close="handleClose" width="30%">
            <span>
                <el-form name="addForm" :model = "categoryAddData" ref= "newcategory" :rules="addrules" label-width="100px" class="gpform">
                  <el-form-item label="分类名称" prop="name">
                    <el-input v-model="categoryAddData.name" placeholder="请输入系统名称" required></el-input>
                  </el-form-item>
                   <el-form-item label="分类URI" prop="uri" require>
                    <el-input v-model="categoryAddData.uri" placeholder="请输入分类url key" required></el-input>
                  </el-form-item>
                  <el-form-item label="分类标题" prop="title" require>
                    <el-input v-model="categoryAddData.title" placeholder="请输入SEO分类标题" required></el-input>
                  </el-form-item>
                   <el-form-item label="分类关键词" prop="keywords" require>
                    <el-input v-model="categoryAddData.keywords" placeholder="请输入分类关键词" required></el-input>
                  </el-form-item>
                   <el-form-item label="分类介绍" prop="description" require>
                    <el-input v-model="categoryAddData.description" placeholder="请用250内个字符介绍您的分类" required></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button @click="addattriDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="addChildCategory('newcategory')">确 定</el-button>
                  </el-form-item>
                </el-form>
              </span>
          </el-dialog>
            <el-dialog :visible.sync="editattriDialogVisible" :before-close="handleClose" width="30%">
            <span>
                <el-form name="editForm" :model = "currEditdata" ref= "editForm" :rules="addrules" label-width="100px" class="gpform">
                  <el-form-item label="分类名称" prop="name">
                    <el-input v-model="currEditdata.name" placeholder="请输入系统名称" required></el-input>
                  </el-form-item>
                   <el-form-item label="分类URI" prop="uri" require>
                    <el-input v-model="currEditdata.uri" placeholder="请输入分类url key" required></el-input>
                  </el-form-item>
                  <el-form-item label="分类标题" prop="title" require>
                    <el-input v-model="currEditdata.title" placeholder="请输入SEO分类标题" required></el-input>
                  </el-form-item>
                   <el-form-item label="分类关键词" prop="keywords" require>
                    <el-input v-model="currEditdata.keywords" placeholder="请输入分类关键词" required></el-input>
                  </el-form-item>
                   <el-form-item label="分类介绍" prop="description" require>
                    <el-input v-model="currEditdata.description" placeholder="请用250内个字符介绍您的分类" required></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button @click="editattriDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="updateChildCategory('editForm')">确 定</el-button>
                  </el-form-item>
                </el-form>
              </span>
          </el-dialog>
            <el-dialog :visible.sync="sortDia" :before-close="handleClose" width="30%">
              <el-form name="editSortForm" :model="currSort" ref= "editSortForm" :rules="addrules" label-width="100px" class="gpform">
                <el-form-item label="分类排序" prop="sort" require>
                  <el-input v-model="currSort.sort" placeholder="请输入您期望的排序数字" required></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button @click="sortDia = false">取 消</el-button>
                  <el-button type="primary" @click="upcatsort('editSortForm')">确 定</el-button>
                </el-form-item>
              </el-form>
            </el-dialog>
          </el-col>
        </el-col>
        <el-col :span="10" class="edittags">
          <el-row>
            <el-col>
              <div class="catatrimaphead">
                <div class="titel">
                  <i class="el-icon-menu"></i>分类属性绑定<el-button type="danger" size="mini" style="margin-left: 14px;" @click="changestatus" round><i class="fa fa-edit"></i>更换分类状态</el-button></div>
                <div class="categorycurrnode">
                  <span v-if="currSelectedNode.ID" class="nodetitle">
                    <i class="el-icon-success" style="color: #67C23A!important;" v-if="currSelectedNode.status"></i>
                    <i class="el-icon-warning" style="color: red!important;" v-else></i>
                    <span class="curtitle">{{ currSelectedNode.name|title }}</span>
                    <div class="currroute">分类路由<i class="fa fa-random"></i>{{ currSelectedNode.route }}</div>
                  </span>
                  <span v-else class="nodetitle">
                    <i class="el-icon-warning" style="color: #F56C6C;"></i>当前未选中任何分类
                  </span>
                </div>
                <div class="ct-item" v-loading="attriload">
                  <span v-if="attridata.endlevel">
                    <span v-for="tag in attridata.rows" :key="tag.ID">
                      <el-tag size="medium" closable class="tagtarget" type="success" @close="ccst(tag.ID)" v-if="tag.isBind">{{ tag.showName }}</el-tag>
                      <el-tag size="medium" closable class="tagtarget" type="danger" @close="ccst(tag.ID)" v-else>{{ tag.showName }}</el-tag>
                    </span>
                  </span>
                  <span v-else class="falsebox"><i class="el-icon-location"></i>当前未选择分类或则此分类为非最终分类</span>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-col>
  </el-row>
</template>
<script>
import ElForm from '../../../node_modules/element-ui/packages/form/src/form'
export default {
  components: {ElForm},
  name: 'Category',
  data () {
    return {
      sData: {},
      initCategoryProps: {
        label: 'name',
        children: 'zones',
        isLeaf: true
      },
      categorydata: [],
      coverupshow: false,
      addattriDialogVisible: false,
      upurl: this.$apiurl,
      categoryAddTemp: '',
      categoryAddData: {},
      uploadattr: {method: 'base.upload'},
      addrules: {
        name: [{ required: true, message: '请输入分类名称', trigger: 'blur' }],
        uri: [{ required: true, message: '分类uri不能为空', trigger: 'blur' }],
        title: [{ required: true, message: '分类标题不能为空', trigger: 'blur' }],
        keywords: [{ required: true, message: '分类关键词不能为空', trigger: 'blur' }],
        description: [{ required: true, message: '分类介绍不能为空', trigger: 'blur' }]
      },
      loading: false,
      attriload: false,
      editattriDialogVisible: false,
      attridata: [],
      currSelectedNode: {},
      currEditdata: {},
      currUpCategory: {},
      currCover: {},
      sortDia: false,
      currSort: {},
      load: false
    }
  },
  mounted: function () {
  },
  methods: {
    routeRepair: function () {
      var that = this
      var para = {}
      para.method = 'shop.categoryrepair'
      this.$http.post(that.$apiurl, para)
      this.$message.success('路由修复指令发送成功,请静待系统处理完成')
    },
    hasloaded: function () {
      this.load.close()
      this.load = ''
    },
    fullLoad () {
      this.load = this.$loading({
        lock: true,
        text: '请求处理中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    },
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    handleClick (tab, event) {
      console.log(tab, event)
    },
    loadCategory (node, resolve) {
      var tempdata = node.data
      if (node.level === 0) {
        var data = {
          name: '店铺根目录',
          PID_id: 0,
          ID: 0
        }
        return resolve([data])
      } else {
        var tid
        tid = tempdata.ID
        if (tid === null) {
          tid = 0
        }
        this.LoadChildCategory(tid, resolve)
      }
    },
    LoadChildCategory (pid, resolve) {
      var that = this
      var params = {
        PID_id: pid,
        method: 'shop.childcategory'
      }
      this.$http.post(that.$apiurl, params).then(function (ret) {
        resolve(ret.body.data)
      })
    },
    append (d) {
      var that = this
      that.categoryAddTemp = d
      that.addattriDialogVisible = true
    },
    categoryedit (data, resolve) {
      this.currEditdata = data
      this.editattriDialogVisible = true
    },
    insert (data, child) {
      if (!data.children) {
        this.$set(data, 'children', [])
      }
      data.children.push(child)
    },
    remove (node, data) {
    },
    addChildCategory (e) {
      var that = this
      that.$refs[e].validate(valid => {
        if (valid) {
          var params = that.categoryAddData
          params['method'] = 'shop.addnode'
          params['pid'] = that.categoryAddTemp.ID
          this.$http.post(that.$apiurl, params).then(function (ret) {
            if (ret.body.data.code === 200) {
              that.$message.success('新分类申请成功')
              that.addattriDialogVisible = false
              console.log(that.categoryAddTemp)
              var node = that.$refs.tree.getCheckedKeys([that.categoryAddTemp.id])
              console.log(node)
              window.location.reload()
            } else {
              that.$alert('分类申请失败，请稍后重试')
            }
          })
        } else {
          that.$alert('请检查表单字段!')
        }
      })
    },
    clickNode (d) {
      var data = {
        method: 'shop.categoryattrigroup',
        CID: d.ID
      }
      this.currSelectedNode = d
      var that = this
      that.attriload = true
      this.$http.post(that.$apiurl, data).then(function (ret) {
        that.attriload = false
        that.attridata = ret.body.data
      })
    },
    ccst: function (tagid) {
      var data = {
        tagid: tagid,
        cid: this.currSelectedNode.ID,
        method: 'shop.attribind'
      }
      var that = this
      this.$http.post(that.$apiurl, data).then(function (ret) {
        if (ret.body.data.code === 200) {
          that.$message.success('标签分类绑定状态修改成功')
          that.clickNode(that.currSelectedNode)
        } else {
          that.$alert('标签分类属性状态修改失败，请稍后重试！')
        }
      })
    },
    updateChildCategory: function (formName) {
      var that = this
      that.$refs[formName].validate(valid => {
        if (valid) {
          var params = that.currEditdata
          params['method'] = 'shop.updatecategory'
          this.$http.post(that.$apiurl, params).then(function (ret) {
            if (ret.body.data.code === 200) {
              that.editattriDialogVisible = false
              that.$message.success('分类更新成功')
            } else {
              that.$alert('分类更新失败,请稍后重试!')
            }
          })
        } else {
          that.$alert('存在不完善的参数项，请详细检查!')
        }
      })
    },
    makecover: function (data) {
      this.coverupshow = true
      this.currCover = data
    },
    handleCoverSuccess: function (response, file, fileList) {
      var that = this
      console.log(that.currCover)
      this.$set(that.currCover, 'cover', response.data.url)
      console.log(that.currCover)
      var params = that.currCover
      params['method'] = 'shop.updatecategory'
      this.$http.post(that.$apiurl, params).then(function (ret) {
        if (ret.body.data.code === 200) {
          that.coverupshow = false
          that.$message.success('分类封面更新成功')
        } else {
          that.$alert('分类封面更新失败,请稍后重试!')
        }
      })
    },
    sortnum: function (data) {
      this.sortDia = true
      this.currSort = data
    },
    upcatsort: function (formname) {
      var that = this
      that.$refs[formname].validate(valid => {
        if (valid) {
          var params = that.currSort
          params.method = 'shop.updatecategory'
          that.$http.post(that.$apiurl, params).then(function (ret) {
            if (ret.body.data.code === 200) {
              that.coverupshow = false
              that.$message.success('分类排序更新成功')
            } else {
              that.$alert('分类排序更新失败,请稍后重试!')
            }
          })
        }
      })
    },
    changestatus: function () {
      var that = this
      var params = {}
      params.method = 'shop.categorystateexchange'
      params.cid = that.currSelectedNode.ID
      that.fullLoad()
      that.$http.post(that.$apiurl, params).then(function (ret) {
        that.hasloaded()
        if (ret.body.data.code) {
          that.$message.success('分类状态更新成功')
          that.$set(that.currSelectedNode, 'status', !that.currSelectedNode.status)
        } else {
          that.$alert('分类状态更新失败,请稍后重试!')
        }
      })
    },
    sSubmit: function () {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shop/Category.vue